import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { POSITION_APPROVAL_LIMIT } from "./apiRoutes";

interface UseGetPositionApprovalLimitProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPositionApprovalLimit = async (communityId: string, year: string) =>
  await axiosAuth.get(`${POSITION_APPROVAL_LIMIT}/${communityId}/${year}`);

const useGetPositionApprovalLimit = ({
  queryParams,
  communityId,
  year,
}: UseGetPositionApprovalLimitProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["position-approval-limit", communityId, year],
    queryFn: () => getPositionApprovalLimit(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId || !!year || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetPositionApprovalLimit;
